import { useEffect, useState } from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import { cookieConsentService } from '../services/cookieConsent';
import { Shield } from './Icons';

export function CookiePreferencesButton() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const syncVisibility = () => {
      setIsVisible(cookieConsentService.readStatus() !== null);
    };

    syncVisibility();
    return cookieConsentService.onChange(syncVisibility);
  }, []);

  useEffect(() => cookieConsentService.onPreferencesRequested(() => {
    setIsVisible(false);
  }), []);

  return (
    <button
      type="button"
      onClick={(event) => {
        event.currentTarget.blur();
        cookieConsentService.requestPreferences();
      }}
      className={`brand-floating-button brand-focus-ring fixed right-5 z-40 inline-flex h-10 w-10 items-center justify-center rounded-full border backdrop-blur-xl transition-[opacity,transform] duration-200 ease-out motion-reduce:transition-none sm:right-8 ${
        isVisible
          ? 'translate-y-0 opacity-100'
          : 'pointer-events-none translate-y-1 opacity-0'
      }`}
      style={{ bottom: 'max(1.25rem, calc(var(--cookie-banner-space, 0px) + 0.75rem))' }}
      aria-label={t('cookies.managePreferences')}
      aria-hidden={!isVisible}
      tabIndex={isVisible ? undefined : -1}
      title={t('cookies.managePreferences')}
    >
      <Shield className="h-4 w-4" />
    </button>
  );
}
